export default "__VITE_ASSET__616a6d1b__"